export const STATUS_ONLINE = "1";
export const STATUS_OFFLINE = "0";
export const SYSTEM_IDLE = "0";
export const STATUS_STOPPED = "0";
export const STATUS_RUNNING = "1";
export const STATUS_ALARM = "2";
export const STATUS_DISCONNECTED = null;

export const CONNECTION_STATUS_CONNECTED = "CONNECTED";
export const CONNECTION_STATUS_DISCONNECTED = "DISCONNECTED";

export const ACTUAL_SYSTEM_STATUS = {
  NOT_READY: 0,
  READY: 1,
  POWER_UP: 2,
  CC: 3,
  PF: 4,
  ENGAGE: 5,
  CPF: 6,
  SDFF: 7,
  SDPF: 8,
  STAND_BY: 9,
  SDNF: 10,
  IDLE_FF: 11, // Feed Flush,
  IDLE_PF: 12 //Permeate Flush
};

export const systemStatusEnum = {
  [STATUS_ONLINE]: "Online",
  [STATUS_OFFLINE]: "Offline",
  [STATUS_DISCONNECTED]: "Disconnected"
};

export const SYSTEM_STATUS = {
  STATUS_ONLINE,
  STATUS_OFFLINE,
  STATUS_STOPPED,
  STATUS_RUNNING,
  STATUS_ALARM,
  STATUS_DISCONNECTED,
  SYSTEM_IDLE
};

export default SYSTEM_STATUS;
